import { debounce } from "lodash";
import { ReactNode, useEffect, useState } from "react";
import { TextInput } from "./textInput";

const handleSearch = (searchFunction: (val: any) => void, query: any) => {
  searchFunction(query);
};

const handleDebouncedSearch = debounce(handleSearch, 800);

export const SearchInput = ({
  searchFunction,
  placeholder = "Search",
  className = "",
  iconClassName = "",
  inputClassName = "",
  customElement,
  debouncedSearch = true,
}: {
  searchFunction: (val: string) => void;
  placeholder?: string;
  className?: string;
  iconClassName?: string;
  inputClassName?: string;
  customElement?: ReactNode;
  debouncedSearch?: boolean;
}) => {
  const [searchParams, setSearchParams] = useState<string>("");

  useEffect(() => {
    if (debouncedSearch) {
      handleDebouncedSearch(searchFunction, searchParams);
    }
    // eslint-disable-next-line
  }, [searchParams]);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!debouncedSearch) {
          searchFunction(searchParams);
        }
      }}
    >
      <TextInput
        placeholder={placeholder}
        hasIcon
        iconSvg="search"
        iconClassName={iconClassName}
        className={`!rounded-[16px] !border !border-grey-200 !bg-transparent !p-3 ${inputClassName}`}
        containerClassName={`!w-full ${className}`}
        value={searchParams}
        onChange={(e) => setSearchParams(e.target.value)}
        type={"text"}
        name={"search"}
        onBlur={() => {}}
        customIcon={
          customElement ? (
            <button
              type="submit"
              onClick={() => {
                searchFunction(searchParams);
              }}
              className="w-fit"
            >
              {customElement}
            </button>
          ) : undefined
        }
        customIconPosition="right"
      />
    </form>
  );
};
